import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';

export default class MarketInsightUnsupportedMarketRoute extends Route {
  @service declare access: Services['access'];
  @service declare transition: Services['transition'];

  beforeModel(): void {
    if (!this.access.isMarketInsightMarketUnsupported) {
      this.transition.redirectToEnabledTab();
      return;
    }
  }
}
